import * as React from 'react';
import { StripeProvider, Elements } from 'react-stripe-elements';
import InjectedCheckoutForm from './components/InjectedCheckoutForm';
// @ts-ignore
import { loadStripe } from "@stripe/stripe-js"

interface ICheckOutProps {
    paymentAmount: number;
    paymentType: string;
    name: string;
    email: string;
    onSuccess: () => void;
    close: () => void;
}
class Checkout extends React.Component<ICheckOutProps, {
    stripe: any
}> {
    constructor(props: ICheckOutProps){
        super(props)

        this.state = {
            stripe: null
        };
    }
    async componentDidMount() {
        // this.setState({stripe: await loadStripe(process.env.GATSBY_STRIPE_API_TOKEN || '')});
        // this.setState({stripe: await loadStripe(process.env.GATSBY_STRIPE_TEST_KEY || '')});
        // const getSpriteData = await loadStripe(process.env.GATSBY_STRIPE_LIVE_KEY || '');

        // this.setState({
        //     stripe: getSpriteData
        // });
        const deployKey:string = process.env.GATSBY_STRIPE_LIVE_KEY || ""
        this.setState({stripe: window.Stripe(deployKey)});


    }
    public render() {
        // const stripeToken = process.env.GATSBY_STRIPE_API_TOKEN || ''
        // console.log({stripeToken});
        return (
            <StripeProvider stripe={this.state.stripe}>
                <Elements>
                    <InjectedCheckoutForm {...this.props}/>
                </Elements>
            </StripeProvider>
        )
    }
}


export default Checkout;